import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MaxDurationShareButton from 'blocks/DownloadPage/components/MaxDurationShareButton';
import { InstagramButton } from 'components/SocialButton';
import useInstagramAuthenticator from 'hooks/useInstagramAuthenticator';
import { videoDurationSecondsSelector } from 'redux/modules/download';
import { hideModal, pushModal } from 'redux/modules/modal';
import { createChainedFunction } from 'utils/functions';
import useOnDownloadPageAction from '../useOnDownloadPageAction';
import { MAX_VIDEO_DURATION_SEC } from './utils';

const InstagramPostButton: React.FC = () => {
  const [shouldReauthenticate, setShouldReauthenticate] = useState<boolean>(
    false,
  );

  const videoDurationSec = useSelector(videoDurationSecondsSelector);

  const { onDownloadPageAction } = useOnDownloadPageAction();
  const dispatch = useDispatch();

  const handleError = useCallback(() => {
    setShouldReauthenticate(true);
    dispatch(hideModal());
  }, [dispatch]);

  const { authenticating, withAuthentication } = useInstagramAuthenticator({
    force: shouldReauthenticate,
    onError: handleError,
  });

  const openSocialShareModal = useCallback(() => {
    dispatch(
      pushModal({
        name: 'SocialShare',
        params: {
          platform: 'instagram',
        },
      }),
    );
  }, [dispatch]);

  return (
    <MaxDurationShareButton
      platform="Instagram"
      videoDurationSec={videoDurationSec}
      maxVideoDurationSec={MAX_VIDEO_DURATION_SEC}
    >
      <InstagramButton
        size="small"
        disabled={authenticating}
        onClick={createChainedFunction(
          () => onDownloadPageAction('instagramShare'),
          withAuthentication(openSocialShareModal),
        )}
      />
    </MaxDurationShareButton>
  );
};

export default InstagramPostButton;
